import type { LogEventWithOptions, ReportLogEventsInput } from '../events';

import { getEventsBatchInfo } from './getEventsBatchInfo';

type BatchReportLogEventsInput = (
  reportLogEventsInput: ReportLogEventsInput,
  batchSizeInBytes: number
) => ReportLogEventsInput[];
export const batchReportLogEventsInput: BatchReportLogEventsInput = (reportLogEventsInput, batchSizeInBytes) => {
  const eventBatches: ReportLogEventsInput[] = [];
  const errorEventsToBeBatched = reportLogEventsInput.errorEvents;
  const performanceEventsToBeBatched = reportLogEventsInput.performanceEvents;
  const infoEventsToBeBatched = reportLogEventsInput.infoEvents;
  let errorStartIndex = 0;
  let performanceStartIndex = 0;
  let infoStartIndex = 0;

  while (
    errorStartIndex < errorEventsToBeBatched.length ||
    performanceStartIndex < performanceEventsToBeBatched.length ||
    infoStartIndex < infoEventsToBeBatched.length
  ) {
    const errorEvents: LogEventWithOptions[] = [];
    const performanceEvents: LogEventWithOptions[] = [];
    const infoEvents: LogEventWithOptions[] = [];

    let logEventsCumulativeSize = 0;

    ({ eventsEndIndex: errorStartIndex, eventsCumulativeSize: logEventsCumulativeSize } = updateLogEventsInputBatches(
      errorEvents,
      errorStartIndex,
      batchSizeInBytes,
      logEventsCumulativeSize,
      errorEventsToBeBatched
    ));

    ({ eventsEndIndex: performanceStartIndex, eventsCumulativeSize: logEventsCumulativeSize } =
      updateLogEventsInputBatches(
        performanceEvents,
        performanceStartIndex,
        batchSizeInBytes,
        logEventsCumulativeSize,
        performanceEventsToBeBatched
      ));

    ({ eventsEndIndex: infoStartIndex, eventsCumulativeSize: logEventsCumulativeSize } = updateLogEventsInputBatches(
      infoEvents,
      infoStartIndex,
      batchSizeInBytes,
      logEventsCumulativeSize,
      infoEventsToBeBatched
    ));

    eventBatches.push({
      errorEvents,
      performanceEvents,
      infoEvents,
    });
  }

  return eventBatches;
};

const updateLogEventsInputBatches = (
  logEvents: LogEventWithOptions[],
  startIndex: number,
  batchSizeInBytes: number,
  intialCumulativeSize: number,
  eventsToBeBatched?: LogEventWithOptions[]
) => {
  let eventsEndIndex = startIndex;
  let cumulativeSizeInBytes = 0;
  let eventsCumulativeSize = 0;
  const availableBatchSizeInBytes = batchSizeInBytes - intialCumulativeSize;
  if (eventsToBeBatched && startIndex < eventsToBeBatched.length) {
    // Extract events for size calculation
    const unwrappedEvents = eventsToBeBatched.map(({ event }) => event);
    ({ eventsEndIndex, cumulativeSizeInBytes } = getEventsBatchInfo(
      unwrappedEvents,
      startIndex,
      availableBatchSizeInBytes
    ));
    logEvents.push(...eventsToBeBatched.slice(startIndex, eventsEndIndex));
    eventsCumulativeSize = intialCumulativeSize + cumulativeSizeInBytes;
  }

  return { eventsEndIndex, eventsCumulativeSize };
};
